'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var linkPropType = _propTypes2.default.shape({
  key: _propTypes2.default.string.isRequired,
  href: _propTypes2.default.string.isRequired
});

var taxonomyPropTypes = {
  _id: _propTypes2.default.string.isRequired,
  geonameId: _propTypes2.default.number.isRequired,
  name: _propTypes2.default.string.isRequired,
  slug: _propTypes2.default.string.isRequired,
  links: _propTypes2.default.arrayOf(linkPropType)
};

var WorldTaxonomy = function (_Component) {
  (0, _inherits3.default)(WorldTaxonomy, _Component);

  function WorldTaxonomy() {
    (0, _classCallCheck3.default)(this, WorldTaxonomy);

    var _this = (0, _possibleConstructorReturn3.default)(this, (WorldTaxonomy.__proto__ || (0, _getPrototypeOf2.default)(WorldTaxonomy)).call(this));

    _this.checkFixContinentsList = function () {
      _this.setState({
        fixContinentsList: _this.continentsRef.getBoundingClientRect().top <= 0
      });
    };

    _this.checkActiveContinent = function () {
      var continents = [].concat((0, _toConsumableArray3.default)(_this.continentRefs)).map(function (_ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
            geonameId = _ref2[0],
            ref = _ref2[1];

        return {
          geonameId: geonameId,
          top: ref.getBoundingClientRect().top
        };
      });

      var activeContinentIndex = continents.findIndex(function (_ref3) {
        var top = _ref3.top;
        return top >= _this.fixedContinentsRef.offsetHeight;
      }) - 1;
      var activeContinent = activeContinentIndex === -2 ? continents[continents.length - 1].geonameId : continents[Math.max(0, activeContinentIndex)].geonameId;

      _this.setState({ activeContinent: activeContinent });
    };

    _this.containerClass = 'quiver-world-taxonomy__container';

    _this.className = function () {
      return (0, _classnames2.default)({
        'quiver-world-taxonomy': true,
        'quiver-world-taxonomy--fixed': _this.state.fixContinentsList
      });
    };

    _this.activeContinentClassName = function (geonameId) {
      return _this.state.activeContinent === geonameId ? 'quiver-world-taxonomy__continents__active' : null;
    };

    _this.continentsList = function (fixed) {
      return _react2.default.createElement(
        'ul',
        { className: fixed ? _this.containerClass : null },
        _this.props.taxonomy.map(function (continent) {
          return _react2.default.createElement(
            'li',
            {
              key: continent.geonameId,
              className: _this.activeContinentClassName(continent.geonameId)
            },
            _react2.default.createElement(
              'a',
              { href: '#' + continent.slug },
              continent.name
            )
          );
        })
      );
    };

    _this.continentRefs = new _map2.default();
    _this.state = {
      fixContinentsList: false,
      activeContinent: null
    };
    return _this;
  }

  (0, _createClass3.default)(WorldTaxonomy, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.checkFixContinentsList);
      window.addEventListener('scroll', this.checkActiveContinent);
      this.checkFixContinentsList();
      this.checkActiveContinent();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.checkFixContinentsList);
      window.removeEventListener('scroll', this.checkActiveContinent);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          taxonomy = _props.taxonomy,
          countryComponent = _props.countryComponent,
          headerSuffix = _props.headerSuffix;

      return _react2.default.createElement(
        'div',
        { className: this.className() },
        _react2.default.createElement(
          'div',
          { className: this.containerClass },
          _react2.default.createElement(
            'h1',
            null,
            'World ',
            headerSuffix
          ),
          _react2.default.createElement(
            'div',
            {
              ref: function ref(_ref4) {
                _this2.continentsRef = _ref4;
              },
              className: 'quiver-world-taxonomy__continents'
            },
            this.continentsList(false)
          ),
          _react2.default.createElement(
            'div',
            {
              ref: function ref(_ref5) {
                _this2.fixedContinentsRef = _ref5;
              },
              className: 'quiver-world-taxonomy__continents quiver-world-taxonomy__continents--fixed'
            },
            this.continentsList(true)
          )
        ),
        taxonomy.map(function (continent) {
          return _react2.default.createElement(
            'div',
            {
              key: continent.geonameId,
              className: 'quiver-world-taxonomy__continent'
            },
            _react2.default.createElement(
              'h2',
              {
                ref: function ref(_ref6) {
                  _this2.continentRefs.set(continent.geonameId, _ref6);
                },
                id: continent.slug,
                className: _this2.containerClass
              },
              continent.name,
              ' ',
              headerSuffix
            ),
            _react2.default.createElement(
              'div',
              { className: 'quiver-world-taxonomy__countries' },
              _react2.default.createElement(
                'ul',
                { className: _this2.containerClass },
                continent.countries.map(function (letter) {
                  return _react2.default.createElement(
                    'li',
                    { key: letter.key },
                    _react2.default.createElement(
                      'div',
                      { className: 'quiver-world-taxonomy__letter' },
                      _react2.default.createElement(
                        'h3',
                        null,
                        letter.key
                      ),
                      _react2.default.createElement(
                        'ul',
                        null,
                        letter.countries.map(function (country) {
                          return _react2.default.createElement(
                            'li',
                            { key: country.geonameId },
                            countryComponent(country)
                          );
                        })
                      )
                    )
                  );
                })
              )
            )
          );
        })
      );
    }
  }]);
  return WorldTaxonomy;
}(_react.Component);

WorldTaxonomy.propTypes = {
  taxonomy: _propTypes2.default.arrayOf(_propTypes2.default.shape((0, _extends3.default)({}, taxonomyPropTypes, {
    countries: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      key: _propTypes2.default.string.isRequired,
      countries: _propTypes2.default.arrayOf(_propTypes2.default.shape(taxonomyPropTypes)).isRequired
    })).isRequired
  }))).isRequired,
  countryComponent: _propTypes2.default.func.isRequired,
  headerSuffix: _propTypes2.default.string
};
WorldTaxonomy.defaultProps = {
  headerSuffix: null
};
exports.default = WorldTaxonomy;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/WorldTaxonomy/WorldTaxonomy.js
// module id = 700
// module chunks = 11